import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFlowEditorModelData } from 'store/slices/flowEditorSlice';
import { setWorkspaceData } from 'store/slices/workspaceSlice';
import useEventTrace from 'utils/CommonRequestConfig';
import useCampignEventTrace from 'utils/CommonRequestConfigForCampign';
const useAxiosFlowFunction = ({

  isWorkspace,
  isWorkspaceDetails,
  isWorkspaceList,
  feedbackresponse
}) => {
  const [flowResponse, setFlowResponse] = useState([]);
  const dispatch = useDispatch();
  const [flowError, setFlowError] = useState('');
  const [flowLoading, setFlowLoading] = useState(false);
  const [controller, setController] = useState();
  const {getDefaultReqConfig} = useEventTrace();
  const {getDefaultCampignReqConfig} = useCampignEventTrace();
  //   const { bearerToken } = useSelector((state) => state.app);
  const axiosFetch = async configObj => {
    const { axiosInstance, method, url, requestConfig } = configObj;

    try {
      setFlowLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      let res="";
      const defaultReqConfig = getDefaultReqConfig();
      const defaultCampignReqConfig = getDefaultCampignReqConfig();
  
      if (method.toLowerCase()==='get') {
        res = await axiosInstance[method.toLowerCase()](url,{headers:{
          "X-Data-Token": defaultReqConfig,
          "X-cmpgn-tkn" : defaultCampignReqConfig
         }}
        );
      }
      else if(method.toLowerCase()==='delete'){
        res = await axiosInstance[method.toLowerCase()](url,{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          },
          ...requestConfig,
          signal: ctrl.signal,
         });
      }
      else{
         res = await axiosInstance[method.toLowerCase()](url,{
          ...requestConfig,
          signal: ctrl.signal,
         },{
          headers: {
            "X-Data-Token": defaultReqConfig,
            "X-cmpgn-tkn" : defaultCampignReqConfig
          }});
        }
   
      if (isWorkspace) {
        dispatch(setWorkspaceData({ ErrorMessage: '' }));
      } else if (isWorkspaceDetails) {
        dispatch(setWorkspaceData({ AppErrorMessage: '' }));
        dispatch(setWorkspaceData({ ErrorMessage: '' }));
      } else if (isWorkspaceList) {
        dispatch(setWorkspaceData({ ErrorMessage: '' }));
      }else if (feedbackresponse) {
        dispatch(setWorkspaceData({ ErrorMessage: '' }));
      }
      
      setFlowResponse(res.data);
      return res.data;
    } catch (err) {
    
      if (isWorkspace) {
        dispatch(setWorkspaceData({ ErrorMessage: err.message }));
      } 
      else if (feedbackresponse) {
        dispatch(setWorkspaceData({ ErrorMessage: err.message }));
      }
       else if (isWorkspaceDetails) {
        if(err.response.data.error === "Conflict"){
          dispatch(setWorkspaceData({ AppErrorMessage: "App name is taken. Try another." }));
        }
        else{
          dispatch(setWorkspaceData({ ErrorMessage: err.message }));
        }
      } else if (isWorkspaceList) {
        dispatch(setWorkspaceData({ ErrorMessage: err.message }));
      }
      setFlowError(err.message);
      throw err;
    } finally {
      setFlowLoading(false);
    }
  };

  useEffect(() => {
    // console.log(controller)

    // useEffect cleanup function
    return () => controller && controller.abort();
  }, [controller]);

  return [flowResponse, flowError, flowLoading, axiosFetch];
};

export default useAxiosFlowFunction;
